import React from 'react';
import {observer} from 'mobx-react';
import {MetaTagModel} from "../models/meta-tag.model";
import {HrefModel} from "../../../core/models/meta-data/href-model";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {WebsiteModuleController} from "../website-module.controller";
import {BaseSchemaModel} from "../../../core/models/schema/base-schema-model";
import {Helmet} from "react-helmet-async";

export class WebsiteModulePageMetaDataProps extends BaseProps {
  controller: WebsiteModuleController;
}

export const WebsiteModulePageMetaData = observer(({controller}: WebsiteModulePageMetaDataProps) => {
  const {state} = controller;
  const {breadcrumbsManager, shouldRenderEntityDescription, isBettingPage, isStoreDomain} = state;

  const {
    canonicalUrl,
    currentCultureName,
    hrefModels,
    shouldRenderHrefModels,
    socialTags,
    description,
    title,
    xDefault,
    dir,
    isNoIndex,
    dataSchemaFAQ,
    dataSchema
  } = state.pageMetadata;
  const schema = breadcrumbsManager.toString();

  return title ? (
    <Helmet htmlAttributes={{lang: currentCultureName, dir}}>
      {
        isNoIndex && !isStoreDomain ? <meta name="robots" content="noindex"/> : null
      }
      {
        isStoreDomain ? <meta name="robots" content="noindex, nofollow"/> : null
      }
      <title>
        {
          title
        }
      </title>
      <meta name="description" content={description}/>
      {
        canonicalUrl ? <link rel="canonical" href={canonicalUrl}/> : null
      }
      {
        !isBettingPage && shouldRenderHrefModels ? <link rel="alternate" href={xDefault} hrefLang="x-default"/> : null
      }
      {
        !isBettingPage && shouldRenderHrefModels ? hrefModels.map((hrefModel: HrefModel) => <link key={hrefModel.hrefLang}
                                                       rel={hrefModel.rel}
                                                       href={hrefModel.href}
                                                       hrefLang={hrefModel.hrefLang}/>) : null
      }
      {
        !isBettingPage ? socialTags.map((metaTagModel: MetaTagModel, index: Number) => <meta key={index}
                                                                            name={metaTagModel.name}
                                                                            content={metaTagModel.content}/>) : null
      }
      {
        shouldRenderEntityDescription ? <script type={"application/ld+json"}>{`{${dataSchemaFAQ?.toString()}}`}</script> : null
      }
      {
        schema ? <script type={"application/ld+json"}>{`{${schema}}`}</script> : null
      }
      {
        dataSchema?.map((schema: BaseSchemaModel, index: Number) => <script key={index} type={"application/ld+json"}>{`{${schema.toString()}}`}</script>)
      }
    </Helmet>
  ) : null
});
